import { type ComponentPropsWithoutRef, forwardRef, memo } from 'react';

import { cn } from '@air/utils-tailwind';

import { useTemporaryFeatureFlags } from '~/hooks/useTemporaryFeatureFlags';

export type SearchCommandActionsProps = ComponentPropsWithoutRef<'div'>;

export const SearchCommandActions = memo(
  forwardRef<HTMLDivElement, SearchCommandActionsProps>(({ className, ...restOfProps }, ref) => {
    const { ui2026 } = useTemporaryFeatureFlags();

    return (
      <div
        className={cn('flex items-center gap-2 ui2026:gap-1', !ui2026 && 'absolute top-0 right-2 bottom-0', className)}
        ref={ref}
        {...restOfProps}
      />
    );
  }),
);

SearchCommandActions.displayName = 'SearchCommandActions';
